var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app',{attrs:{"dark":""}},[(!_vm.hasInitialData)?_c('Loader'):_vm._e(),(_vm.hasInitialData)?_c('v-row',{staticClass:"no-gutters"},[_c('transition',[_c('keep-alive',[_c('router-view')],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }